import { Checkbox, FormControlLabel } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'

export default function NdaSupContract({ checkedItems, handleCheck, index, businessUnitId, handleCheckboxChange, companyInformation }) {

  const arrayData = checkedItems?.find(x => x.businessUnitId === businessUnitId)

  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear().toString().substr(-2);
  const shortDate = `${day}/${month}/${year}`;
  const storedLang = localStorage.getItem('lang')

  return (
    <Box component="main">
      <Box>
        <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0 }}>
          {storedLang === 'en' ? `This Confidentiality Agreement (“Agreement”) is made on ${shortDate} (the “Effective Date”)

BETWEEN:

(1) GL Group acting for itself and on behalf of its affiliates and

(2) ${companyInformation?.companyName}, (company number ${companyInformation?.taxId}) organized and existing under the laws of AZ and having its registered address at ${companyInformation?.companyAdress} (“Recipient”).

The Disclosing Party and the Recipient shall hereinafter be collectively referred to as the “Parties” or individually as a “Party”.

WHEREAS:

The Disclosing Party wishes to discuss with and disclose to the Recipient certain information in relation to the Disclosing party’s and its subsidiaries' current and future operations in AZ in order to engage the services of the Recipient (the “Permitted Purpose”).

IT IS HEREBY AGREED AS FOLLOWS:

1. The following definitions shall apply for the purposes of this Agreement:

“Affiliate” means in relation to the Disclosing Party:

(i) the Disclosing Party’s ultimate holding company and any subsidiary (other than the Disclosing Party itself) of the Disclosing Party’s ultimate holding company; or

(ii) if the Disclosing Party is not a subsidiary of another company, any subsidiary of the Disclosing Party.

“Confidential Information” means all information communicated to or obtained by Recipient, directly or indirectly from the Disclosing Party (either through itself or its Affiliates and its and their representatives) in connection with the Permitted Purpose, whether written, electronic, or any other form or medium in which such information may be kept, or in the course of any oral or written communications, including geological and geophysical data, maps, models, interpretations and forecasts, technical designs, marketing arrangements, development plans, and other technical, contractual, or commercial data and information.

“Person” means an individual or other entity (legal or otherwise), including a corporation, joint-stock company, limited liability company, partnership, or joint venture.

2. The Disclosing Party is willing, in accordance with the terms and conditions of this Agreement, to disclose the Confidential Information to the Recipient.

3. In consideration of the disclosure referred to in Clause 2 above, the Recipient agrees that the Confidential Information shall only be used for the Permitted Purpose, shall be kept strictly confidential and shall not be sold, traded, published, or otherwise disclosed to anyone in any manner whatsoever, without the Disclosing Party’s prior written consent, except as provided for in Clause 4 below.

4. The Recipient may disclose the Confidential Information without the Disclosing Party’s prior written consent only to the extent such information:

(a) is already known to the Recipient as of the date of disclosure hereunder;

(b) is in the public domain or becomes available to the public other than through the act or omission of the Recipient or of any other Person to whom Confidential Information is distributed pursuant to this Agreement;

(c) is required to be disclosed by law or by any government, statutory or regulatory body provided that the Recipient shall make all reasonable efforts to give prompt written notice to the Disclosing Party prior to such disclosure; or

(d) is acquired independently from a third party that represents that it has the right to disclose such information at the time it is acquired by the Recipient.

5. The Recipient shall acquire no proprietary interest in, or right to, the Confidential Information, and the Disclosing Party may demand the return thereof at any time upon giving written notice to the Recipient. Within thirty (30) days of receipt of such notice, the Recipient shall return all of the original Confidential Information provided on behalf of the Disclosing Party and shall destroy or cause to be destroyed all copies and reproductions (in whatever form, including but not limited to, electronic media) in its possession and in the possession of Persons to whom it was disclosed pursuant to this Agreement.

6. Clause 5 shall not apply to:

(a) Confidential Information that is required to be retained by the Recipient by law, including by stock exchange regulations or governmental order, decree, regulation, or rule; and/or

(b) Confidential Information which has been automatically backed-up on the computer systems of the Recipient. To the extent that such computer back-up procedures create copies of the Confidential Information, the Recipient may retain such copies for the period they normally archive backed-up computer records.

7. The return or destruction of Confidential Information and the ability to retain certain data pursuant to Clause 6 shall not release the Recipient from any of its obligations under this Agreement.

8. This Agreement shall remain in force for:

(a) three (3) years from the Effective Date; or

(b) three (3) years from the date that the Confidential Information is last disclosed to the Recipient under the Agreement; or

(c) three (3) years from the termination of the agreement for services, as may be executed, between the Parties, whichever occurs last.

9. All notices to be given hereunder by either Party shall be in writing and sent by registered post or courier to the other Party at its respective address set forth in this Agreement or such other address as may be notified from time to time by either Party to the other. A notice shall only be effective upon actual receipt at the appropriate address.

10. No amendment, changes, or modification to this Agreement shall be valid unless the same are in writing and signed by a duly authorized representative of each of the Parties.

11. Any provision of this Agreement which is found to be invalid or otherwise unenforceable shall not affect the validity or enforceability of the remaining provisions.

12. This Agreement comprises the complete agreement between the Parties in relation to the disclosure of the Confidential Information and supersedes all prior communications and agreements between the Parties relating thereto whether written or oral.

13. This Agreement may be executed by the Parties hereto in counterpart with the same effect as if the Parties hereto had signed the same document. All counterparts of this Agreement shall be construed together and shall constitute one and the same instrument.

14. This Agreement shall not create a binding commitment for the Disclosing Party to engage the services of the Recipient, and that no such commitment shall exist until the Parties enter into a definitive agreement in that respect.

15. This Agreement shall be governed by and construed in accordance with the laws of the Republic of Azerbaijan and each Party hereby submits to the exclusive jurisdiction of the courts of the Republic of Azerbaijan.

16. This Agreement may be entered into by way of exchange of e-mails.

17. Disclosing Party reserves the right to amend this Confidentiality Agreement at any time. Any changes will be effective immediately upon notification to Recipient, and continued compliance with the terms will signify acceptance of such amendments.

`:
            `
Məxfilik Razılaşması ("Razılaşma")

Qüvvəyə Minmə Tarixi: ${shortDate}

Tərəflər:

GL Group, öz adından və filiallarının adından fəaliyyət göstərir ("Açıqlayan Tərəf"); və
Azərbaycan qanunlarına əsasən təsis edilmiş və qeydiyyat ünvanı ${companyInformation?.taxId} olan, ${companyInformation?.companyName} şirkəti ("Alıcı").
Bundan sonra birlikdə "Tərəflər" və ya ayrı-ayrılıqda "Tərəf" adlandırılacaqlar.

Giriş: Açıqlayan Tərəf, Resipientin xidmətlərindən istifadə etmək üçün özünün və filiallarının Azərbaycanda cari və gələcək əməliyyatları ilə bağlı məlumatları Resipientlə müzakirə etmək və ona açıqlamaq istəyir ("İcazə Verilən Məqsəd").

Razılaşma Şərtləri:

Təriflər:

"Filial": Açıqlayan Tərəfin əsas holdinq şirkəti və onun törəmə şirkətləri.
"Məxfi Məlumat": İcazə Verilən Məqsədlə əlaqədar, hər hansı formada Açıqlayan Tərəfdən Resipientə ötürülən məlumatlar (geoloji və geofiziki məlumatlar, xəritələr, texniki dizaynlar və s.).
"Şəxs": Korporasiya, ortaqlıq, fiziki və ya hüquqi şəxs.
Açıqlama: Açıqlayan Tərəf Məxfi Məlumatı Resipientə açıqlamağa razıdır.

Məxfilik Öhdəliyi: Resipient Məxfi Məlumatı yalnız İcazə Verilən Məqsəd üçün istifadə edəcək, üçüncü şəxslərə açıqlamayacaq (4-cü bənddə göstərilən hallar istisna olmaqla).

İstisnalar:

Resipient əvvəlcədən məlum olan, ictimaiyyət üçün əlçatan, qanun və ya hökumət tələbi ilə açıqlanması tələb olunan və ya üçüncü şəxsdən müstəqil əldə edilən məlumatları açıqlaya bilər.
Mülkiyyət Hüquqları: Məxfi Məlumata dair mülkiyyət hüquqları Açıqlayan Tərəfə məxsus qalır və Açıqlayan Tərəf istənilən vaxt Məxfi Məlumatın geri qaytarılmasını tələb edə bilər.

Saxlanılma İstisnaları:

Qanuni tələblərə əsasən və ehtiyat nüsxə olaraq saxlanılan Məxfi Məlumat istisna təşkil edir.
Məxfi Məlumatın Geri Qaytarılması: 6-cı bəndə uyğun olaraq saxlanılan məlumatlar istisna olmaqla, Məxfi Məlumat geri qaytarılacaq və ya məhv ediləcəkdir.

Razılaşmanın Müddəti: Razılaşma qüvvəyə minmə tarixindən və ya Məxfi Məlumatın son açıqlanma tarixindən üç (3) il müddətində qüvvədə qalacaq.

Bildirişlər: Yazılı şəkildə tərtib olunmalı və sifarişli poçt və ya kuryer vasitəsilə müvafiq ünvana göndərilməlidir.

Dəyişikliklər: Razılaşmaya yalnız yazılı şəkildə, Tərəflərin səlahiyyətli nümayəndələrinin imzası ilə təsdiqlənmiş dəyişikliklər etibarlı sayılır.

Etibarsızlıq: Etibarsız hər hansı bir müddəa qalan müddəaların etibarlılığına təsir göstərməyəcəkdir.

Tam Razılaşma: Bu Razılaşma Məxfi Məlumatın açıqlanması ilə bağlı Tərəflər arasında tam razılaşmanı təşkil edir və əvvəlki razılaşmaları əvəz edir.

Nüsxələrin Hüquqi Qüvvəsi: Bu Razılaşmanın imzalı bütün nüsxələri eyni hüquqi qüvvəyə malikdir.

Öhdəlik Yaratmır: Bu Razılaşma Resipientin xidmətlərindən istifadə etmək üçün Tərəflər arasında məcburi öhdəlik yaratmır.

Müqavilə Hüququ və Yurisdiksiya: Azərbaycan qanunlarına əsasən tənzimlənir və Azərbaycan məhkəmələrinin yurisdiksiyasına tabedir.

Elektron İmzalama: Bu Razılaşma e-məktub mübadiləsi yolu ilə bağlana bilər.

Dəyişiklik Hüququ: Açıqlayan Tərəf bu Razılaşmaya dəyişiklik etmək hüququnu özündə saxlayır.
`}
          <br></br>
          GL LTD CFO Emil Jabrailzade <br></br>
          {companyInformation?.companyName} <br></br>
          {companyInformation?.contactPerson}

        </p>

        <FormControlLabel
          control={
            <Checkbox
              checked={arrayData?.isAgreed}
              onChange={(event) => {
                handleCheckboxChange(event, index.toString());
                handleCheck(arrayData?.businessUnitId);
              }}
            />
          }
          label='Agreed'
        />

      </Box>
    </Box>
  )
}